import { ElementIconType } from "@/components/ui/icons";
import { ExportModeTab } from "@/modes/export-mode/export-mode-types";
import { moveToExportMode } from "@/modes/export-mode/export-mode-utils";
import { setActiveElement } from "@/store/selections-slice";
import {
  ContextMenuAction,
  ContextMenuActionHandlerArgs,
  ContextMenuActionType,
} from "../action-types";

export const SCANS_EXPORT: ContextMenuAction = {
  type: ContextMenuActionType.scansExport,
  label: "Scans export",
  secondaryText: "E57 file format",
  icon: ElementIconType.ExportIcon,
  handler: ({
    elementID,
    dispatch,
  }: ContextMenuActionHandlerArgs): Promise<void> => {
    // Make sure the active element is correctly set before entering export mode
    dispatch(setActiveElement(elementID));

    // Activate the export tool and change to export mode
    moveToExportMode(dispatch, ExportModeTab.scans);

    return Promise.resolve();
  },
};
